import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';
import { UserObservationBody } from './post-send-observations.type';

export async function postSendObservations({ body }: UserObservationBody) {
  const { response, data } = await BACKEND.post(ENDPOINT.SEND_INCONSISTENCIES_OBSERVATION, { body });

  return {
    response,
    summary: data,
  };
}
